export default __webpack_public_path__ + "static/media/allergy_page1.7177b7ab.jpg";